// @ts-expect-error Package does not export types
export { deserialize } from 'deserialize-json-api'
